<template>
  <div id="callback" class="mbsc-cloak">
    <!-- <a class="btn-dismiss" @click="btndismiss"> -->
    <a class="btn-dismiss">
      <i class="fa-times"></i>
    </a>
    <div class="modal-body" :hidden="sending">
      <h2 class="topic">ข้อมูลสำหรับการติดต่อ</h2>
      <hr />
      <form class="form" id="form-data" mbsc-form @submit.prevent="checkForm">
        <fieldset>
          <div class="has--error">
            <label>
              <abbr class="required" title="required">*</abbr>ชื่อ
            </label>
            <input
              type="text"
              id="cb_name"
              name="cb_name"
              v-model="form.cb_name"
              maxlength="200"
              value="ใส่ข้อมูลตรงนี้แล้วนะหนู"
              :disabled="sending"
            />
            <span class="mbsc-err-msg" v-if="$v.form.cb_name.$error">ข้อมูลที่ใส่ไม่ถูกต้อง</span>
          </div>
          <div>
            <label>
              <abbr class="required" title="required">*</abbr>อีเมล
            </label>
            <input
              type="email"
              id="cb_email"
              name="cb_email"
              v-model="form.cb_email"
              maxlength="200"
              value
              :disabled="sending"
            />
            <span class="mbsc-err-msg" v-if="$v.form.cb_email.$error">ข้อมูลที่ใส่ไม่ถูกต้อง</span>
          </div>
          <div>
            <label>
              <abbr class="required" title="required">*</abbr>เบอร์มือถือ
            </label>
            <input
              type="text"
              id="cb_phone"
              name="cb_phone"
              v-model="form.cb_phone"
              maxlength="10"
              value
              :disabled="sending"
            />
            <span
              class="mbsc-err-msg"
              v-if="$v.form.cb_phone.$error"
            >กรุณาระบุเบอร์มือถือให้ครบ 10 หลัก</span>
          </div>
          <div>
            <label>
              <abbr class="required" title="required">*</abbr> ข้อความเพิ่มเติม
            </label>
            <textarea
              trows="3"
              id="cb_message"
              name="cb_message"
              v-model="form.cb_message"
              maxlength="200"
              :disabled="sending"
            ></textarea>
            <span class="mbsc-err-msg" v-if="$v.form.cb_message.$error">ข้อมูลที่ใส่ไม่ถูกต้อง</span>
          </div>
          <div class="col-1-1">
            <label>
              เลือกเวลาที่ให้ 724 โทรกลับ
              <select
                id="cb_time_0"
                v-model="form.cb_time"
                class="select-time"
              >
                <option value="0">ให้โทรกลับทันที</option>
                <option value="2">ให้โทรกลับช่วง 08.30 - 12.00 น.</option>
                <option value="3">ให้โทรกลับช่วง 12.00 - 13.00 น.</option>
                <option value="4">ให้โทรกลับช่วง 13.00 - 17.00 น.</option>
                <option value="5">ให้โทรกลับช่วง 17.00 - 19.00 น.</option>
              </select>
            </label>
          </div>
          <input type="text" id="cb_url" name="cb_url" v-model="form.cb_url" style="display:none;" />
          <input type="text" id="service_type" name="service_type" v-model="form.service_type" style="display:none;"/>
          <button class="btn--warning" v-if="!sending">ให้เจ้าหน้าที่ติดต่อกลับ</button>
        </fieldset>
      </form>
    </div>
    <div class="modal-body" :hidden="!sending">
      <h2 class="topic">ได้รับข้อมูลเรียบร้อยแล้ว</h2>
      <h2 class="topic">เจ้าหน้าที่จะติดต่อกลับถึงท่านโดยเร็วที่สุด</h2>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapState } from "vuex";
import { required, email, minLength, numeric } from "vuelidate/lib/validators";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      errors: [],
      form: {
        cb_name: "",
        cb_email: "",
        cb_phone: "",
        cb_message: "",
        cb_time: "0",
        cb_url: "",
        service_type: ""
      },
      sending: false
    };
  },
  validations: {
    form: {
      cb_name: { required },
      cb_email: { required, email },
      cb_phone: { required, min: minLength(10), numeric },
      cb_message: { required }
    }
  },
  computed: {
    ...mapGetters(["codecallback"]),
    ...mapState({ salepages: state => state.salepage })
  },
  async mounted() {
      this.form.service_type = this.salepages.sale_page.service_type
      showCallback = $("#callback")
      .mobiscroll()
      .popup({
        buttons: [],
        cssClass: "modal modal-callback",
        display: "center",
        layout: "liquid",
        showOverlay: !0
      })
      .mobiscroll("getInst");
    $(".popup-callback").on("click", function() {
      return showCallback.show(), !1;
    }),
      $(".btn-dismiss").on("click", function() {
        return showCallback.hide(), !1;
      }),
      $(".select-time")
        .mobiscroll()
        .select({
          buttons: ["set"],
          display: "bubble",
          headerText: "เลือกเวลาที่ให้ 724 โทรกลับ",
          layout: "liquid",
          setText: "เลือก",
          showScrollArrows: !0,
          responsive: {
            custom: {
              breakpoint: 1025,
              buttons: [],
              display: "bubble",
              headerText: "",
              layout: "fixed",
              showScrollArrows: !1,
              touchUi: !1
            }
          }
        });

    await this.getCodeCallback();
    this.form.cb_url = this.codecallback;
  },
  methods: {
    ...mapActions({ CreateCallback: "CreateCallback" }),
    ...mapActions({ getCodeCallback: "getCodeCallback" }),
    btndismiss() {
      showCallback.hide();
    },
    checkForm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      } else {
        this.SubmitForm();
      }
    },
    SubmitForm() {
      this.sending = true;
      let data = $("#form-data").serialize();
      this.CreateCallback(data);
      window.setTimeout(() => {
        this.sending = false;
        this.clearForm();
        showCallback.hide(), !1;
      }, 4000);
    },
    clearForm() {
      this.$v.$reset();
      this.form.cb_name = "";
      this.form.cb_email = "";
      this.form.cb_phone = "";
      this.form.cb_message = "";
    }
  }
};
</script>

<style>
</style>